import { useEffect, useRef, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import ZoomPlugin from 'chartjs-plugin-zoom';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Legend,
} from 'chart.js';
import 'chartjs-plugin-zoom';
import { Box, Card, Grid, Tooltip, Typography } from '@mui/material';
import ChevronLeftSharpIcon from '@mui/icons-material/ChevronLeftSharp';
import ChevronRightSharpIcon from '@mui/icons-material/ChevronRightSharp';
import { abbreviateNumber, formatingChart } from 'utils/utils';
import CommonNoDataFound from 'components/CommonNoDataFound/CommonNoDataFound';
import BookingCard from 'assets/images/BookingReportCard.svg';

const CommonReportCard = (props) => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Legend,
    ZoomPlugin
  );

  const [analytics, setAnalytics] = useState({});
  const chartRef = useRef(null);

  useEffect(() => {
    if (props?.barChartData?.labels && props?.barChartData?.datasets) {
      // const tempFormatingResponse = formatingChart(props?.barChartData);
      const tempFormatingResponse = props?.barChartData;
      setAnalytics(tempFormatingResponse);
    }
  }, [props?.barChartData]);

  useEffect(() => {
    if (chartRef.current) {
      const chartInstance = chartRef.current.getContext('2d');
      chartInstance.chart.zoom('x', {
        min: 0,
        max: 1.5,
      });
    }
  }, []);

  const onZoomPluse = () => {
    chartRef.current.zoom(1.1);
  };

  const onZoomMinus = () => {
    chartRef.current.zoom(0.9);
  };

  const onPanPluse = () => {
    chartRef.current.pan({ x: 100 }, undefined, 'default');
  };

  const onPanMinus = () => {
    chartRef.current.pan({ x: -100 }, undefined, 'default');
  };

  const onResetZoom = () => {
    chartRef.current.resetZoom();
  };

  return (
    <Box className="commonReportCard pb40">
      <Grid container gap={6}>
        <Grid item xs={12} sm={12} md={4.5}>
          <Card className="p20 customCard">
            <Typography variant="body1" className="colorBlack pb40">
              {props?.title ? props?.title : 'Total No. of Booking'}
            </Typography>
            <Box className="justifyCenter flexColumn cardContent">
              <img
                src={props?.image ? props?.image : BookingCard}
                alt="cardImage"
              />
              <Tooltip title={'₹' + props?.count} placement="top">
                <Typography
                  variant="textLarge"
                  className="colorPrimary fw600 pt10 pb30"
                >
                  {props?.barName === 'revenue' && '₹'}
                  {props?.barName === 'revenue' ? abbreviateNumber(props?.count) : props?.count}
                </Typography>
              </Tooltip>
            </Box>
          </Card>
        </Grid>
        <Grid container item className="chartContainer" gap={2} xs={12} sm={12} md={7}>
        <div className="chartWrapper width100">
        <div className="buttonContainer p10"> {/* Container for buttons */}
              <button onClick={onResetZoom} className='button'>Zoom Reset</button>
              <button onClick={onZoomPluse} className='button'>Zoom In</button>
              <button onClick={onZoomMinus} className='button'>Zoom Out</button>
        </div>
        <div className="buttonContainers">
              <ChevronLeftSharpIcon onClick={onPanPluse} className='cursor' disable={analytics?.labels?.length === 0}/>
             <ChevronRightSharpIcon onClick={onPanMinus} className='cursor'/>
        </div>
          <Card className="p20 customCard width100 height100percent">
            {analytics?.labels?.length > 0 ? (
              <Bar
                id="barChart"
                options={props?.option}
                data={analytics}
                ref={chartRef}
              />
            ) : (
              <CommonNoDataFound />
            )}
          </Card>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CommonReportCard;
